import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import './design-system/tokens.css';   // ← brand tokens (colors, type, spacing)
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container as HTMLElement);

  root.render(
    <App />
    // <React.StrictMode>
    // </React.StrictMode>
  );
}

reportWebVitals();
